module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAOCAYAAAD5YeaVAAAABHNCSVQICAgIfAhkiAAAANhJREFUKJF1kc15wjAMhl+ZJRymMJA77mQkm5RJIu5N4xF6ajMF4pC42HlAJz365O9HFooKh9OwthFQzDSl7z7jDiCENobDyTBTTPo0jYJJvxJYCG0sGetBqZaJgF0IxwugKY3XbMU3+0/vG+b57zbPvz/eN/hm3zlEIrjbwnK8YKZpGqXOsOBkiW3/CnOAFn51tZVVuuwbULfs3M8AaRo//hlF4vNs9zNmWqV9Vxl3KX0pZl3xIZvTPe2Ur4fst1zcziq5MuBWTWqmNiI2AFoGfh9mCfzS/wN0QG5w13ILWgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/SsendLocation.png
// module id = 7Lnb
// module chunks = 1